<script>
import { pageTitleMixin } from '@ubic/vue-mixins';
import { colorsCategorical, permissions } from '@/constants';
import ErrorAccessDenied from '@/components/ErrorAccessDenied';
import FormError from '@/components/FormError';
import DepartmentFields from './components/DepartmentFields';
import service from './service';

export default {
  pageTitle: 'Новый департамент',
  mixins: [pageTitleMixin],
  data () {
    return {
      isSaving: false,
      error: '',
      name: '',
      color: colorsCategorical[0],
    };
  },
  computed: {
    hasWritePermission () {
      return this.$store
        .getters['auth/checkPermission'](permissions.DEPARTMENT_WRITE);
    },
  },
  methods: {
    handleFieldsChange (fields) {
      this.name = fields.name;
      this.color = fields.color;
    },

    handleNameInput (value) {
      this.name = value;
    },
    handleColorInput (value) {
      this.color = value;
    },
    async handleSubmit (e) {
      e.preventDefault();

      if (this.isSaving) {
        return;
      }

      this.isSaving = true;
      this.error = '';

      try {
        const { name, color } = this;

        await service.create({ name, color });
        this.$emit('dataupdate');

        this.handleClose();
      } catch (error) {
        this.isSaving = false;
        this.error = 'Ошибка при создании департамента';
      }
    },

    handleClose () {
      this.$emit('close');
      this.$router.replace('/departments');
    },
  },
  render () {
    if (!this.hasWritePermission) {
      return (
        <u-modal onClose={this.handleClose}>
          <ErrorAccessDenied />
        </u-modal>
      );
    }

    const { isSaving, error } = this;

    return (
      <u-modal onClose={this.handleClose}>
        <u-title
          slot="header"
          level="2"
        >
          Новый департамент
        </u-title>

        <form
          slot="content"
          action="#"
          method="post"
          onSubmit={this.handleSubmit}
        >
          <DepartmentFields
            values={{ color: this.color }}
            disabled={isSaving}
            onChange={this.handleFieldsChange}
          />

          {Boolean(error) && (
            <FormError>
              {error}
            </FormError>
          )}

          <div class="form-footer">
            <u-btn
              size="wide"
              type="submit"
            >
              {isSaving
                ? <u-spinner inline />
                : 'Создать'}
            </u-btn>
          </div>
        </form>
      </u-modal>
    );
  },
};
</script>
